import authConfig from '~/app/config/auth'
import hotJarConfig from '~/app/config/hotJar'

const initializeAppConfig = () => {
  authConfig()
  hotJarConfig()
}

export default initializeAppConfig
